export default "__VITE_ASSET__CQF2Y6_E__"